import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import TransactionCashFlowType from './TransactionCashFlowType';

/**
 * Componente responsável por listar os tipos de movimentações.
 */
const TransactionCashFlowTypeSelect = (props) => {
  
  const { t } = useTranslation();
  const { value, onChange, error } = props;
  const options = [
    { value: TransactionCashFlowType.IN, label: t('in') },
    { value: TransactionCashFlowType.OUT, label: t('out') }
];

  return (
    <CustomSelect options={options} value={value} onChange={onChange} isClearable placeholder={t("select")} error={error}/>
  )
}

export default TransactionCashFlowTypeSelect;